import React from "react";
import { Container, Grid } from "@mui/material";

import WelcomeCard from "../CMS/WelcomeCard";
import BreadcrumbBuilder from "./BreadcrumbBuilder";
import LoginCard from "../../Common/Card/LoginCard";
import X360Avatar from "./X360Avatar";

function Dashboard() {
    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={"X-E360"} />
                </Grid>

                <Grid item xs={6}>
                    <LoginCard
                        avatar={<X360Avatar />}
                        appName="Doctor 360°"
                        loginURL="https://user.doctor360.co.uk/login"
                    />
                </Grid>
            </Grid>
        </Container>
    );
}
export default Dashboard;
